export default __webpack_public_path__ + "static/media/D23.56a4a179.png";